export default __webpack_public_path__ + "static/media/Brassard of Ben Morgh.b5d53e57.jpg";